import { Wrench } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAppSettingsStore } from "@/store/appSettings.store";
import { V3Logo } from "./ui/v3/logo";

// Shown instead of the app while VITE_MAINTENANCE_MODE is on: v3.2 tokens,
// so it follows the saved Light / Dark / System theme.
export const Maintenance = () => {
  const { t } = useTranslation();
  // Reads the saved theme so the page opens in it (the store applies it).
  useAppSettingsStore((state) => state.theme);
  return (
    <main className="flex min-h-screen flex-col items-center bg-v3-canvas px-4 font-v3 text-v3-text supports-[min-height:100dvh]:min-h-dvh">
      <header className="flex h-16 shrink-0 items-center">
        <V3Logo size={28} />
      </header>
      <div className="flex w-full flex-1 items-center justify-center pb-16">
        <div className="w-full max-w-lg rounded-[18px] bg-v3-panel p-6 shadow-v3-hairline sm:p-8">
          <span
            aria-hidden
            className="flex size-11 items-center justify-center rounded-[12px] bg-v3-warn-tint text-v3-warn-text"
          >
            <Wrench className="size-5" />
          </span>
          <h1 className="mt-4 text-[20px] font-semibold leading-7 tracking-tight">
            {t("maintenance.title")}
          </h1>
          <p className="mt-2 text-[14.5px] leading-relaxed text-v3-text">
            {t("maintenance.paused")}
          </p>
          <p className="mt-2 text-[14px] leading-relaxed text-v3-text-2">
            {t("maintenance.reload")}
          </p>
        </div>
      </div>
    </main>
  );
};
